import { FormFieldToggle as ChordsFormFieldToggle } from '~/chords/FormField';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FormFieldToggle = withClassNameHoc(ChordsFormFieldToggle);
